"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils/utils");

var _Text = _interopRequireDefault(require("./Text"));

var _InputConstants = require("./InputConstants");

require("./Range.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputRange = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputRange, _Component);

  var _super = _createSuper(InputRange);

  function InputRange(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputRange);
    _this = _super.call(this, props);
    _this.handleChangeFrom = _this.handleChangeFrom.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangeTo = _this.handleChangeTo.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      from: '',
      fromText: /*#__PURE__*/_react.default.createRef(),
      to: '',
      toText: /*#__PURE__*/_react.default.createRef(),
      validityClass: '',
      isFromTouched: false,
      isToTouched: false,
      invalidReasons: []
    };
    return _this;
  }

  (0, _createClass2.default)(InputRange, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        from: nextProps.from,
        to: nextProps.to
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        from: this.props.from || '',
        to: this.props.to || ''
      });
    }
  }, {
    key: "handleChangeFrom",
    value: function handleChangeFrom(value) {
      var _this2 = this;

      this.setState({
        from: value
      }, function () {
        _this2.props.onChangeFrom(value);
      });
    }
  }, {
    key: "handleChangeTo",
    value: function handleChangeTo(value) {
      var _this3 = this;

      this.setState({
        to: value
      }, function () {
        _this3.props.onChangeTo(value);
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      var _this4 = this;

      var from = this.state.fromText;
      var to = this.state.toText;
      var validityClass = this.state.validityClass;
      var invalidReasons = []; //Error in Start Range

      if (from.current.state.invalidReasons.length > 0) {
        invalidReasons = invalidReasons.concat(from.current.state.invalidReasons);
      } //Error in End Range


      if (to.current.state.invalidReasons.length > 0) {
        invalidReasons = invalidReasons.concat(to.current.state.invalidReasons);
      } //Start Range exceeds End Range


      if (from.current.state.value.length > 0 && to.current.state.value.length > 0) {
        if (from.current.state.value.toUpperCase() > to.current.state.value.toUpperCase()) {
          invalidReasons.push('Starting range should not exceed Ending Range');
        }
      }

      if (invalidReasons.length > 0) {
        validityClass = _InputConstants.CLASSES.STATUS.INVALID;
      } else {
        validityClass = _InputConstants.CLASSES.STATUS.VALID;
      }

      this.setState({
        isToTouched: true,
        validityClass: validityClass,
        invalidReasons: invalidReasons
      }, function () {
        _this4.props.onBlur(_this4.state.invalidReasons);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var placeholderFrom = '';
      var placeholderTo = '';

      if (this.props.placeholder) {
        if (typeof this.props.placeholder.map === 'function') {
          placeholderFrom = this.props.placeholder[0];
          placeholderTo = this.props.placeholder[1];
        } else if (typeof this.props.placeholder === 'string') {
          placeholderFrom = this.props.placeholder;
          placeholderTo = this.props.placeholder;
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(_InputConstants.CLASSES.TYPE.RANGE, " ").concat(this.state.validityClass, " ").concat(this.props.className)
      }, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
        className: "from",
        ref: this.state.fromText,
        onChange: function onChange(value) {
          return _this5.handleChangeFrom(value);
        },
        minLength: this.props.minLength,
        maxLength: this.props.maxLength,
        value: this.state.from,
        placeholder: placeholderFrom
      }, (0, _utils.omit)(this.props, ['placeholder', 'onBlur', 'onChange', 'className', 'divider']))), /*#__PURE__*/_react.default.createElement("span", {
        className: "divider"
      }, this.props.divider), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
        className: "to",
        ref: this.state.toText,
        onChange: function onChange(value) {
          return _this5.handleChangeTo(value);
        },
        onBlur: this.handleBlur,
        minLength: this.props.minLength,
        maxLength: this.props.maxLength,
        value: this.state.to,
        placeholder: placeholderTo
      }, (0, _utils.omit)(this.props, ['placeholder', 'onBlur', 'onChange', 'className', 'divider']))));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        from: _propTypes.default.string,
        to: _propTypes.default.string,
        placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
        divider: _propTypes.default.string,
        validator: _propTypes.default.oneOf(_InputConstants.VALIDATORS),
        minLength: _propTypes.default.int,
        maxLength: _propTypes.default.int
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        validator: _InputConstants.VALIDATORS.NONE,
        divider: 'to',
        className: '',
        minLength: '',
        maxLength: '',
        onBlur: function onBlur() {},
        onChangeFrom: function onChangeFrom() {},
        onChangeTo: function onChangeTo() {}
      };
    }
  }]);
  return InputRange;
}(_react.Component);

exports.default = InputRange;